"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.save = exports.CacheImpl = void 0;
const atom_1 = require("@rixio/atom");
const operators_1 = require("rxjs/operators");
const wrapped_1 = require("@rixio/wrapped");
const mapped_subject_1 = require("./mapped-subject");
const index_1 = require("./index");
class CacheImpl extends mapped_subject_1.MappedSubject {
    constructor(_atom, _loader) {
        super(_atom, wrapped_1.pendingWrapped);
        this._atom = _atom;
        this._loader = _loader;
        wrapped_1.markWrappedObservable(this);
        this.clear = this.clear.bind(this);
    }
    get atom() {
        return this._atom;
    }
    get valueAtom() {
        // @ts-ignore
        return this._atom.lens("value");
    }
    get(force = false) {
        if (force) {
            this.clear();
        }
        return getFinalValue(this);
    }
    set(value) {
        this.atom.set(index_1.createFulfilledCache(value));
    }
    modifyIfFulfilled(updateFn) {
        this.atom.modify(s => {
            if (s.status === "fulfilled") {
                return Object.assign(Object.assign({}, s), { value: updateFn(s.value) });
            }
            else {
                return s;
            }
        });
    }
    clear() {
        this.atom.set(index_1.idleCache);
    }
    _onValue(x) {
        switch (x.status) {
            case "idle":
                save(this._loader(), this._atom).then();
                this.checkAndNext(wrapped_1.pendingWrapped);
                break;
            case "pending":
                this.checkAndNext(wrapped_1.pendingWrapped);
                break;
            case "rejected":
                this.checkAndNext(wrapped_1.createRejectedWrapped(x.error, this.clear));
                break;
            case "fulfilled":
                this.checkAndNext(wrapped_1.createFulfilledWrapped(x.value));
        }
    }
    checkAndNext(value) {
        if (value !== this.getValue()) {
            this.next(value);
        }
    }
}
exports.CacheImpl = CacheImpl;
function getFinalValue(state$) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = yield state$
            .pipe(operators_1.filter(x => x.status === "rejected" || x.status === "fulfilled"), operators_1.first())
            .toPromise();
        switch (result.status) {
            case "rejected":
                return Promise.reject(result.error);
            case "fulfilled":
                return Promise.resolve(result.value);
            default:
                throw new Error("Never happens");
        }
    });
}
function save(promise, atom) {
    return __awaiter(this, void 0, void 0, function* () {
        const observable = wrapped_1.fromPromise(promise).pipe(operators_1.map(index_1.toCache));
        yield atom_1.Atom.set(atom, observable).toPromise();
    });
}
exports.save = save;
